
import { useState } from 'react';

export default function VideoPayment() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [wallet] = useState({ balance: 50000 });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 헤더 */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              {/* 홈 버튼 추가 */}
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg cursor-pointer whitespace-nowrap flex items-center space-x-2"
              >
                <i className="ri-home-line text-sm"></i>
                <span>홈</span>
              </button>
              <h1 className="text-xl font-bold">동영상 유료 시청</h1>
            </div>
            <div className="flex items-center space-x-4">
              {/* 지갑 잔액 */}
              <div className="bg-blue-50 px-4 py-2 rounded-lg">
                <span className="text-sm text-blue-600 font-medium">
                  잔액: {wallet.balance.toLocaleString()}원
                </span>
              </div>
              {/* 충전 버튼 */}
              <button
                onClick={() => setShowChargeModal(true)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg cursor-pointer whitespace-nowrap"
              >
                충전
              </button>
              {/* 관리자 버튼 */}
              <button
                onClick={() => setIsAdmin(!isAdmin)}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg cursor-pointer whitespace-nowrap"
              >
                {isAdmin ? '사용자 모드' : '관리자 모드'}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* 메인 콘텐츠 */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">동영상 유료 시청 서비스</h2>
          <p className="text-gray-600">프리미엄 동영상 콘텐츠를 시청하실 수 있습니다.</p>
        </div>
      </main>

      {/* 충전 모달 */}
      {showChargeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-bold mb-4">지갑 충전</h3>
            <p className="text-gray-600 mb-4">충전할 금액을 선택해주세요.</p>
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setShowChargeModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 cursor-pointer whitespace-nowrap"
              >
                취소
              </button>
              <button
                onClick={() => setShowChargeModal(false)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg cursor-pointer whitespace-nowrap"
              >
                충전
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
